/*global site*/
export const $ = jQuery;

export function locale(key){
    try {
        return site['locale'][key];
    } catch(e) {
        return key;
    }

}

export function isfancyOpen(){
    return  !isEmpty($('.fancybox-opened:visible'));
}


export function fixDoubleSlash(str) {
    while(str.match(/(\/)\/+/g)) {
        str = str.replace(/(\/)\/+/g, "$1");
    }
    return str;
}

export function isEmpty(obj) {
    return obj === undefined || obj === null || (typeof(obj) === 'object' && obj.hasOwnProperty('length') && obj.length === 0) || (typeof(obj) === 'string' && obj.length === 0) || (Array.isArray(obj) &&  obj.length === 0);
}

export function scrollToPos (to,cb) {
    $("html, body").animate({
        scrollTop: to ? to : 0
    },400, function() {
        if(typeof cb === 'function' ){
            cb()
        }
    });
}


export function set_css_variables(key, value) {
    document.documentElement.style.setProperty(`--${key}`, value);
}

export function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

export function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while(c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if(c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return false;
}
